//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { BookingPriceOverrideType } from './Enums';

export class BookingPriceOverrideItem extends ItemBase {
    OverrideType: BookingPriceOverrideType = BookingPriceOverrideType.None;
    OverrideAmount: number = 0;

    constructor(initializer?: Partial<BookingPriceOverrideItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "BookingPriceOverrideItem";
}
